// extracted by mini-css-extract-plugin
export default {"employee-form":"employee-form_employee-form__-6IzY"};